import { useState } from "preact/hooks";
import { toast } from "react-hot-toast";
import { apiClient, apiUrl, teamsWebhookPath } from "../../constants.ts";
import {
  Button,
  Collapsible,
  CopyableValue,
  inputClass,
  PageSpinner,
  TokenDisplay,
} from "./components.tsx";
import { useAuth, useQuery } from "./db.ts";

export const TeamsConfig = ({ id }: { id: string }) => {
  const token = useAuth().user?.refresh_token;
  const [appId, setAppId] = useState("");
  const [appPassword, setAppPassword] = useState("");
  const { data, error, isLoading } = useQuery({
    bots: { $: { where: { id } } },
  });
  if (isLoading) return <PageSpinner />;
  if (error) return <div>Error: {error.message}</div>;
  const [bot] = data.bots;
  if (!bot) return <div>No bot found</div>;
  const webhookUrl = [apiUrl, teamsWebhookPath, bot.id].join("/");
  return (
    <Collapsible title="Microsoft Teams">
      <div className="flex flex-col gap-3 max-w-2xl">
        <div className="text-sm text-text-tertiary-light dark:text-text-tertiary">
          Register this bot in Azure Bot Service or Microsoft Bot Framework and
          use the messaging endpoint below. Teams proactive replies require an
          inbound conversation first so the bot can store routing details.
        </div>
        <CopyableValue value={webhookUrl} label="Messaging endpoint" />
        {!bot.teamsAppId
          ? (
            <>
              <div>
                <label>App ID</label>
                <input
                  value={appId}
                  onInput={(e) => setAppId(e.currentTarget.value)}
                  className={inputClass}
                  placeholder="Microsoft app ID"
                />
              </div>
              <div>
                <label>App password</label>
                <input
                  value={appPassword}
                  onInput={(e) => setAppPassword(e.currentTarget.value)}
                  className={inputClass}
                  placeholder="Microsoft app password"
                />
              </div>
              <Button
                className="w-fit"
                disabled={!token || !appId || !appPassword}
                onClick={() => {
                  if (!token) return;
                  toast.promise(
                    apiClient({
                      token,
                      endpoint: "set-teams-bot",
                      payload: { botId: bot.id, appId, appPassword },
                    }),
                    {
                      loading: "Connecting Teams bot...",
                      success: (res) => {
                        if (res.success) {
                          setAppId("");
                          setAppPassword("");
                          return "Microsoft Teams configured";
                        }
                        throw new Error(res.error);
                      },
                      error: (err) => `Failed: ${err.message}`,
                    },
                  );
                }}
              >
                Connect Teams
              </Button>
            </>
          )
          : (
            <div className="flex flex-col gap-2 max-w-md">
              <CopyableValue value={bot.teamsAppId} label="App ID" />
              {bot.teamsAppPassword && (
                <TokenDisplay
                  label="App password"
                  token={bot.teamsAppPassword}
                />
              )}
            </div>
          )}
      </div>
    </Collapsible>
  );
};
